import { enUS, enGB, enAU, fr, frCA, ar } from 'date-fns/locale';
import { dateFormats } from '@ellucian/react-design-system/core/i18n';
var supportedLocales = {
  'en-US': enUS,
  en_US: enUS,
  'en-GB': enGB,
  en_GB: enGB,
  'en-AU': enAU,
  en_AU: enAU,
  es: dateFormats.es,
  'es-CL': dateFormats.esCL,
  es_CL: dateFormats.esCL,
  'es-MX': dateFormats.esMX,
  es_MX: dateFormats.esMX,
  'es-CO': dateFormats.esCO,
  es_CO: dateFormats.esCO,
  'es-EC': dateFormats.esEC,
  es_EC: dateFormats.esEC,
  'es-PE': dateFormats.esPE,
  es_PE: dateFormats.esPE,
  'es-DO': dateFormats.esDO,
  es_DO: dateFormats.esDO,
  'es-PR': dateFormats.esPR,
  es_PR: dateFormats.esPR,
  fr: fr,
  'fr-CA': frCA,
  fr_CA: frCA,
  ar: ar
};
export default supportedLocales;